import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';

import AdminRolesTable from './AdminRolesTable';

const AdminUsers = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchSubscriptions = async () => {
    setLoading(true);
    try {
      const response = await axios({
        method: 'GET',
        url: `/api/v1/admin/getAllSubscriptions`,
      });
      setSubscriptions(response.data.data);
    } catch (err) {
      console.log('Error->', err.response?.data?.message || err.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  return (
    <div className="adminUsers">
      <h1>Roles</h1>
      {loading && subscriptions.length === 0 ? (
        <CircularProgress sx={{ m: 3 }} />
      ) : (
        subscriptions.length > 0 && (
          <AdminRolesTable subscriptions={subscriptions} onRefresh={fetchSubscriptions} />
        )
      )}
      {loading && subscriptions.length > 0 && <CircularProgress sx={{ m: 2 }} />}
    </div>
  );
};

export default AdminUsers;
